import { useState } from 'react';
import { ImageField, ImageInput, useRecordContext } from 'react-admin';
import { useWatch } from 'react-hook-form';
import { findIndex } from 'lodash';
import { ImagesGalleryModal } from '../ImagesGalleryModal';

type ImageItem = {
	src: string;
	title?: string;
};

const Image = ({ onClick }: { onClick: (src: string) => void }) => {
	const a = useRecordContext();

	return (
		<div
			onClick={() => {
				if (a?.src) onClick(a.src);
			}}
		>
			<ImageField source="src" title="title" />
		</div>
	);
};

export const ImagesInput = ({ inputSource = 'image' }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [imageIndex, setImageIndex] = useState(0);
	const images = useWatch({ name: inputSource }) as ImageItem[] | undefined;

	const parsedImages =
		images?.map(({ src, title }) => ({
			original: src,
			thumbnail: src,
			description: title ?? '' // Default to empty string
		})) ?? [];

	const handleClick = (imgSrc: string) => {
		setImageIndex(findIndex(parsedImages, ['original', imgSrc]));
		setIsOpen(true);
	};

	return (
		<>
			<ImageInput
				multiple={true}
				source={inputSource}
				label="Фото"
				placeholder={
					<p>Натисніть або перетягніть кілька фото, щоб завантажити</p>
				}
				helperText={false}
				accept={{ 'image/*': [] }}
				onChange={event => console.log('Change event:', event)}
			>
				<Image onClick={handleClick} />
			</ImageInput>
			<ImagesGalleryModal
				startIndex={imageIndex}
				items={parsedImages}
				isOpen={isOpen}
				onClose={() => setIsOpen(false)}
			/>
		</>
	);
};
